<template>
    <v-container class="mt-4 pa-0">
        <v-flex>
            <v-card color="primary" class="elevation-1" :style="{ textAlign: 'center' }" v-if="!!repair.length">
                
                <!-- TOOLBAR -->

                <v-toolbar color="primary" flat>
                    <v-tooltip bottom>
                        <v-toolbar-side-icon slot="activator" @click="reset()" icon>
                            <v-icon>arrow_back</v-icon>
                        </v-toolbar-side-icon>
                        <span>Return to Barcode</span>
                    </v-tooltip>
                    <h2>
                        <span class="hidden-xs-only">Repair Reference -</span>
                        <a target="new"
                            :href="`https://ops.bohmtech.com/web#id=${repair[0].id}&view_type=form&model=mrp.repair`"
                            :style="{ color: '#F04E23', textDecoration: 'none' }" class="ml-2">{{ repair[0].name }}</a>
                        <span class="hidden-xs-only" v-if="repair[0].partner_id"> - {{ repair[0].partner_id[1] }}</span>
                    </h2>
                    <v-spacer></v-spacer>

                    <h3 class="hidden-xs-only">{{ repair[0].product_id[1] }}</h3>
                </v-toolbar>
                
                <div v-if="partner && partner == 3679910">
                    <v-card color="primary" class="mb-5 elevation-0" :style="{ textAlign: 'center' }">
                        <h2 class="mt-2">Victra Product. Use the grading app!</h2>
                        <v-btn color="primary" @click="reset()">Go Home</v-btn>
                    </v-card>
                </div>
                <!-- NOT SET UP -->
                
                <div v-else-if="!requireModel && repairState != 'done'">
                    <v-card color="primary" class="mb-5 elevation-0" :style="{ textAlign: 'center' }">
                        <h2 class="mt-2">This product has not been set up for labeling!</h2>
                        <v-btn color="primary" @click="reset()">Go Home</v-btn>
                    </v-card>
                </div>
   
                <!-- NOT TESTED -->
                
                <div v-else-if="!hasBeenTested">
                    <v-card color="primary" class="mb-5 elevation-0" :style="{ textAlign: 'center' }">
                        <h2 class="mt-2">This product has not been tested!</h2>
                        <v-btn color="primary" @click="reset()">Go Home</v-btn>
                    </v-card>
                </div>

                <!-- FINISHED REPAIR -->

                <div v-else-if="repairState === 'done'">
                    <v-card color="primary" class="mb-5 elevation-0" :style="{ textAlign: 'center' }">
                        <h2 class="mt-2">This repair order has been completed!</h2>
                        <v-card height="550px" class="mt-5" color="primary" flat>
                            <v-select :items="allPrinters" v-model="selectedPrinter" color="secondary"
                                label="Select Printer" box :style="{ width: '50%', margin: 'auto' }"></v-select>

                            <v-select :items="['medium', 'small']" v-model="selectedSize" color="secondary"
                                    label="Select Label Size" box :style="{ width: '50%', margin: 'auto' }"></v-select>
                            <v-btn color="secondary" @click="printLabel()">Print Label</v-btn>
                            <v-btn color="primary" @click="reset()">Go Home</v-btn>
                        </v-card>
                    </v-card>
                </div>


                <div v-else-if="repairState === 'draft'  || repairState === 'under_repair'">
                    <v-card color="primary" class="mb-5 elevation-0" :style="{ textAlign: 'center' }">
                        <v-card height="620px" class="mt-2" color="primary" flat>
                            <div>
                                <h2 class="my-2">Select a Condition</h2>
                                <v-text-field
                                    v-model="model"
                                    label="Model #"
                                    color="secondary"
                                    :style="{ width: '50%', margin: 'auto' }"
                                    box
                                ></v-text-field>
                                <v-select :items="['Certified Refurbished', 'Refurbished', 'Pre-Owned', 'Used', 'Failed']"
                                    v-model="condition" color="secondary" label="Select Condition" box
                                    :style="{ width: '50%', margin: 'auto' }"></v-select>

                                <v-btn v-if="foundProduct[0].x_require_model" color="success" @click="submitRepair">Submit Grade</v-btn>
                            </div>                            
                        </v-card>
                    </v-card>
                </div>
            </v-card>
        </v-flex>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";
import Common from "@/mixins/Common";

export default {
    name: "repair-label",
    mixins: [LoginCheck, Common],

    data() {
        return {
            repairState: false,
            originalState: false,
            condition: "",
            model: "",
            partner: false
        }
    },
    computed: {
        ...mapGetters({
            repair: "repair/getRepair",
            repairOperations: "repair/getRepairOperations",
            storedPrinter: "repair/getSelectedPrinter",
            storedPrintSize: "repair/getStoredPrintSize",
            allPrinters: "repair/getAllPrinters",
            user: "app/getUser",
            foundProduct: "product/getProduct",
        }),

        requireModel() {
            if (this.foundProduct.length) {
                return this.foundProduct[0].x_require_model;
            } else {
                return false;
            }
        },

        hasBeenTested() {
            let testingStep = this.repairOperations.filter(
                (item) => item.product_id[0] == 743
            );
            if (testingStep.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        selectedPrinter: {
            get() {
                return this.storedPrinter;
            },
            set(val) {
                return this.$store.commit("repair/setSelectedPrinter", val);
            },
        },

        selectedSize: {
            get() {
                return this.storedPrintSize;
            },
            set(val) {
                return this.$store.commit("repair/setStoredPrintSize", val);
            },
        },

    },
    async beforeMount() {
        await this.searchServices({ serial: this.$route.params.id });
        await this.getAllPrinters();
        await this.getOperation({ id: this.repair[0].id });
        this.partner = await this.getPartner({ po: this.repair[0].x_origin });
        if (this.repair.length) {
            this.repairState = this.repair[0].state;
            this.originalState = this.repair[0].state;
            this.model = this.repair[0].x_model_number ? this.repair[0].x_model_number : "";
            await this.productSearch({
                body: {
                    kwargs: {
                        product: false,
                        id: this.repair[0].product_id[0]
                    }
                }
            });
        } else {
            this.reset();
        }
    },

    methods: {
        ...mapActions({
            searchServices: "repair/searchServices",
            completeWatchRepair: "repair/completeWatchRepair",
            getOperation: "repair/getRepairOperations",
            getAllPrinters: "repair/getAllPrinters",
            printProductLabel: "repair/printProductLabel",
            productSearch: "product/search",
            getGradehistory: "repair/fetchGradeHistory",
            addOperation: "repair/addOperation",
            repairUpdate: "repair/updateRepair",
            getPartner: "repair/getPartner"
        }),

        async submitRepair() {
            if (!this.condition) {
                this.$store.dispatch("app/setSnackbar", {
                    text: "Please Select a Condition!",
                    color: "red",
                });
                return;
            }

            if (!this.model) {
                this.$store.dispatch("app/setSnackbar", {
                    text: "Please Enter a Model Number!",
                    color: "red",
                });
                return;
            }

            if (this.model != this.repair[0].x_model_number) {
                await this.repairUpdate({
                    body: {
                        id: this.repair[0].id,
                        x_model_number: this.model
                    }
                });
            }




            const res = await this.completeWatchRepair({
                id: this.repair[0].id,
                condition: this.condition,
                polished: false,
            });
            if (res.success) {
                this.$store.dispatch("app/setSnackbar", {
                    text: "Grade Submitted!",
                    color: "green",
                });

                await this.addOperation({
                    repairID: this.repair[0].id,
                    step: "Label"
                });
                this.repairState = "done";
            } else {
                this.$store.dispatch("app/setSnackbar", {
                    text: res.message,
                    color: "red",
                });
            }
            
        },

        async printLabel() {
            if (!this.selectedPrinter) {
                this.$store.dispatch("app/setSnackbar", {
                    text: "Please Select a Printer!",
                    color: "red",
                });
            } else if (!this.selectedSize) {
                this.$store.dispatch("app/setSnackbar", {
                    text: "Please Select a Size!",
                    color: "red",
                });
            } else {
                await this.searchServices({ serial: this.$route.params.id });

                await this.productSearch({
                    body: {
                        kwargs: {
                            product: false,
                            id: this.repair[0].x_finished_product[0]
                        }
                    }
                });


                await this.printProductLabel({
                    printer: this.selectedPrinter,
                    sn: this.repair[0].name,
                    sku: this.foundProduct[0].default_code,
                    barcode: this.foundProduct[0].barcode,
                    description: this.foundProduct[0].x_sales_description || this.foundProduct[0].display_name,
                    owner: this.repair[0].x_customer_code,
                    size: this.selectedSize
                });

                this.reset();
            }
        },

        reset() {
            this.$store.commit("repair/setRepair", []);
            this.currentStep = 1;
            this.$router.push("/repair-labeling");
        }

    }
};
</script>

<style>
</style>